import { Component, OnInit } from '@angular/core';
import { DashboardService } from '@service/dashboard.service';
import { ToasterLibraryService } from '@service/index';

@Component({
    selector: 'app-billing-overview-widget',
    templateUrl: './billing-overview-widget.component.html',
    styleUrls: ['./billing-overview-widget.component.scss']
})
export class BillingOverviewWidgetComponent implements OnInit {
    public isLoaded = false;
    public statements: Array<any> = [];
    public monthlyBilling: Array<any> = [];

    constructor(
        private dashboardService: DashboardService,
        private toasterLibrary: ToasterLibraryService
    ) { }

    ngOnInit() {
        this.loadData();
    }

    loadData() {
        this.isLoaded = false;
        this.dashboardService.getBillingStatements().subscribe(
            (res: any) => {
                if (res && res.data && Array.isArray(res.data)) {
                    this.statements = res.data.slice(0, 5);
                } else if (Array.isArray(res)) {
                    this.statements = res.slice(0, 5);
                }
                this.isLoaded = true;
            },
            (err: any) => {
                this.toasterLibrary.error(null, err?.error?.message || 'Failed to load billing statements');
                this.isLoaded = true;
            }
        );

        this.dashboardService.getBillingMonthly().subscribe(
            (res: any) => {
                if (res && res.data && Array.isArray(res.data)) {
                    this.monthlyBilling = res.data;
                } else if (Array.isArray(res)) {
                    this.monthlyBilling = res;
                }
            },
            (err: any) => {
                console.error('Failed to load monthly billing', err);
            }
        );
    }
}